import React,{useState, useEffect} from 'react'
import './styles/home.css'
import {db,auth } from './firebase'
import { getDefaultNormalizer } from '@testing-library/react'
import {Link, Redirect} from 'react-router-dom'



export default function Home() {
    const [loading,setLoading]=useState(true)
    const [loggedIn, setLoggedIn]=useState(false)
    const [handle,setHandle]=useState('')
    const [rating, setRating]=useState(0)
    const [rank,setRank]=useState('')
    const [img,setImg]=useState(null)



    //===================================================================
    //
    //toggling the bar
    //
    //===================================================================
    const openDrawer=()=>{
        const drawer=document.querySelector('.drawer')
        drawer.classList.toggle('open-drawer')
        //console.log('done')
    }



   
    //===================================================================
    //
    //  Getting data from the database
    //
    //===================================================================
    const getUserInfo =()=>{
        auth.onAuthStateChanged(user=>{
            if (user){
                setLoggedIn(true)
                //accessing db and finding the files and getting the handle
                db.collection(user.email).doc('data').get()
                    .then(res=>{
                        console.log(res.data().handle)
                        setHandle(res.data().handle)
                        getCFHandleData(res.data().handle)
                        setLoading(false)
                        
                    })
              
            }
            else{
                alert('Login please!')
                setLoggedIn(false)
             
                
            }
        })  
    }
    useEffect(()=>getUserInfo(),[])
    //getUserInfo()
    //===================================================================
    //
    //  Getting handle info from api
    //
    //===================================================================

    const getCFHandleData=(handle)=>{
        let url=`https://codeforces.com/api/user.info?handles=${handle}`
        fetch(url)
            .then(data=>data.json())
                .then(data=>{
                    //console.log(data)
               
                    let rating=data.result[0].rating
                    let rank=data.result[0].rank

                    setImg(data.result[0].avatar)
                    setRating(rating)
                    setRank(rank)    
                })
                .catch(err=>console.log(err))
         
          
    }
    //===================================================================
    //
    //  Creating The Graph
    //
    //===================================================================
    
                    
    //===================================================================
    //
    //  Creating The loading Screen
    //
    //===================================================================
    if (loading){
        return(
            <div className="loading-screen">
            <i class="material-icons loading"> hourglass_empty</i>
            <p>Loading......</p>
            </div>
        );
    }
    if(!loggedIn){
        return(<Redirect to='/'/>)
    }
    else{
        return (
        <div>
            <div className="navbar">
                <h3>Codeforces tracked</h3>
                <i class="material-icons md-64" onClick={openDrawer}>menu</i>
                

                <ul class='drawer'>
                    <div className="topbar"></div>
                    <Link to='/home' style={{textDecoration:'none', color:'black'}}><li>My Account</li></Link>
                    <Link to='/problems'style={{textDecoration:'none', color:'black'}}><li>Saved Problems</li></Link>
                    <Link to='/submissions' style={{textDecoration:'none', color:'black'}}><li>Submissions</li></Link>
                    <Link to='/friends' style={{textDecoration:'none', color:'black'}}><li>Track friends</li></Link>
                
                    <li onClick={()=>auth.signOut()}>Log Out</li>
                </ul>
            </div>

            <div className="title">
                <h1>My Account</h1>
            </div>

            <div className="main-container">
                <img src={img}/>

                <div className="text-items">
                    <h2>{handle}</h2>
                    <h3>{rating}</h3>
                    <h4>{rank}</h4>
                </div>
                
            </div>
        </div>
    )


    }

    
}
